import api from "@/services/api";
import { PaginatedResponse } from "@/types";
import {
  ScrapedBrand,
  ScrapedBrandFilters,
  UpdateScrapedBrand,
} from "@/types/scraped-brand";

export class ScrapedBrandRepository {
  async findAll(
    filters: ScrapedBrandFilters,
  ): Promise<PaginatedResponse<ScrapedBrand>> {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        params.append(key, value.toString());
      }
    });

    const response = await api.get(
      `/v1/admin/scrape-brands?${params.toString()}`,
    );

    return response.data as PaginatedResponse<ScrapedBrand>;
  }

  async update(data: UpdateScrapedBrand): Promise<ScrapedBrand> {
    const response = await api.patch<ScrapedBrand>(
      `/v1/admin/scrape-brands/${data.id}`,
      {
        blacklist: data.blacklist,
        linkedBrandId: data.linkedBrandId,
      },
    );

    return response.data;
  }
}
